import ClaimStatusSelect from './ClaimStatusSelect'

export default ClaimStatusSelect
